export function imageDate (image) {
  const [date, time] = image._date.split(' ')
  return new Date(date.replace(/:/g, '-') + ' ' + time)
}



// WEBPACK FOOTER //
// ./src/utils/date.js